import React from 'react';
import nextId from "react-id-generator";
import { setPrefix } from "react-id-generator";
class Footer extends React.Component {
    
    constructor(props) {
        super(props);
        setPrefix("Footer-");
    }
      
      render() {
        
   
        return (
          <div>
            <div className="footer-top-line"></div>
            <div className="footer-style">
            <div className="text-center footer-style-text">Version :{this.props.versionNumber}</div>
              <div className="text-center footer-style-text">© 2020-{new Date().getFullYear()} Beckman Coulter, Inc. All rights reserved.
              <br></br>Confidential & Company Proprietary
            </div>
            </div>            
          </div>
        );
      }
}

export default Footer